import { getUrl, sessionExpired } from "../setEnvironment";

class UsersAPI {
  constructor() {
    this.URL = getUrl();
    this.login = this.login.bind(this);
    this.registerUser = this.registerUser.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.disableUser = this.disableUser.bind(this);
    this.enableUser = this.enableUser.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
  }

  async login(username, password) {
    try {
      const response = await fetch(this.URL + "/user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: username,
          pass: password,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (response.status === 200) {
        return json;
      } else {
        throw json;
      }
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario que ejecuta la acción se resuelve en el backend desde el token de
  // sesión, ya no se envía como parámetro.
  async registerUser(name, password, role, token) {
    try {
      const response = await fetch(this.URL + "/user/registerUser", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          name: name,
          pass: password,
          role_id: role,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario que ejecuta la acción se resuelve en el backend desde el token de
  // sesión, ya no se envía como parámetro.
  async enableUser(user, token) {
    try {
      const response = await fetch(this.URL + "/user/enableUser", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          name: user,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario que ejecuta la acción se resuelve en el backend desde el token de
  // sesión, ya no se envía como parámetro.
  async disableUser(user, token) {
    try {
      const response = await fetch(this.URL + "/user/disableUser", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          name: user,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario que ejecuta la acción se resuelve en el backend desde el token de
  // sesión, ya no se envía como parámetro.
  async getUsers(token) {
    try {
      const response = await fetch(
        this.URL + "/user/getAllUsers",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      ).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario que ejecuta la acción se resuelve en el backend desde el token de
  // sesión, ya no se envía como parámetro — `user` sigue siendo necesario: es a quién se le
  // cambia la contraseña (uno mismo, o cualquier otro si quien ejecuta es Experto/Admin).
  async changePassword(user, pass, token) {
    try {
      const response = await fetch(this.URL + "/user/changePass", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          name: user,
          new_pass: pass,
        }),
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario que ejecuta la acción se resuelve en el backend desde el token de
  // sesión, ya no se envía como parámetro.
  async updateUser(name, new_name, role, token) {
    try {
      const response = await fetch(this.URL + "/user/updateUser", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          name: name,
          new_name: new_name,
          new_role_id: role,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario que ejecuta la acción se resuelve en el backend desde el token de
  // sesión, ya no se envía como parámetro.
  async deleteUser(name, token) {
    try {
      const response = await fetch(this.URL + "/user/deleteUser", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          name: name,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }
}

let _usersAPI = null;

const initUsersAPI = () => {
  if (!_usersAPI) {
    _usersAPI = new UsersAPI();
  }
  return _usersAPI;
};

const getUsersAPI = () => {
  return initUsersAPI();
};

export { initUsersAPI, getUsersAPI };
